<div class="sds-parser-container"  style="width: 100%;">
  <h2 >SDS自動解析工具</h2>
  <!-- upload-section 與 tab-header 僅在 sdsdata 不存在時顯示 -->
  <ng-container *ngIf="!selectedfile ">
    <div class="upload-section">
      <div class="sds-parser-file">
        <ng-container *ngIf="selectedfileurl; else fileInputBlock">
          <a [href]="selectedfileurl" target="_blank">{{ selectedfilname}}</a>
        </ng-container>
        <ng-template #fileInputBlock>
          <input type="file" (change)="onFileSelected($event)" accept="application/pdf" />
        </ng-template>
      </div>
      <button
        (click)="uploadAndParse()"
        [disabled]="!(selectedFile || (selectedfileurl && selectedfilname)) || loading"
      >
        {{ loading ? '解析中...' : '開始解析' }}
      </button>
    </div>

  </ng-container>
  <div class="progress-bar-container" >
    <div class="progress-status-list">
      <span *ngFor="let done of finished; let i = index"
            [class.progress-done]="done"
            [class.progress-todo]="!done">
        {{i}}
      </span>
    </div>
    <div class="progress-bar-bg">
      <div class="progress-bar-fg" [style.width.%]="progressPercent"></div>
    </div>
  </div>

  <div class="tab-header" *ngIf="(selectedFile || selectedfileurl) && showTabHeader">
      <button [class.active]="activeTab===0" (click)="activeTab=0">解析模式</button>
      <button [class.active]="activeTab===1" (click)="activeTab=1" [disabled]="!parsedModel">編輯模式</button>
      <button [class.active]="activeTab===2" (click)="activeTab=2" [disabled]="!parsedModel">檢視模式</button>
    </div>
  <div class="results-section" *ngIf="(selectedFile || selectedfileurl) && activeTab===0">
    <div class="sds-section">
      <div [innerHTML]="parsercontenttemp_0"></div>
    </div>
    <div class="sds-section">
      <div [innerHTML]="parsercontenttemp_1"></div>
    </div>
    <div class="sds-section">
      <div [innerHTML]="parsercontenttemp_2"></div>
    </div>
    <div class="sds-section">
      <div [innerHTML]="parsercontenttemp_3"></div>
    </div>
    <div class="sds-section">
      <div [innerHTML]="parsercontenttemp_4"></div>
    </div>
    <div class="sds-section">
      <div [innerHTML]="parsercontenttemp_5"></div>
    </div>
    <div class="sds-section">
      <div [innerHTML]="parsercontenttemp_6"></div>
    </div>
    <div class="sds-section">
      <div [innerHTML]="parsercontenttemp_7"></div>
    </div>
    <div class="sds-section">
      <div [innerHTML]="parsercontenttemp_8"></div>
    </div>
    <div class="sds-section">
      <div [innerHTML]="parsercontenttemp_9"></div>
    </div>
    <div class="sds-section">
      <div [innerHTML]="parsercontenttemp_10"></div>
    </div>
    <div class="sds-section">
      <div [innerHTML]="parsercontenttemp_11"></div>
    </div>
    <div class="sds-section">
      <div [innerHTML]="parsercontenttemp_12"></div>
    </div>
    <div class="sds-section">
      <div [innerHTML]="parsercontenttemp_13"></div>
    </div>
    <div class="sds-section">
      <div [innerHTML]="parsercontenttemp_14"></div>
    </div>
    <div class="sds-section">
      <div [innerHTML]="parsercontenttemp_15"></div>
    </div>
    <div class="sds-section">
      <div [innerHTML]="parsercontenttemp_16"></div>
    </div>
  </div>
  <div class="results-section" *ngIf="(selectedFile || selectedfileurl) && activeTab===1 && parsedModel ">
    <div class="json-preview-container">
      <div class="json-meta">
        <!-- <div><b>語言：</b>{{ parsedModel.Language }}</div> -->
         <div *ngIf="parsedModel.SpendTime"><b>花費時間：</b>{{ parsedModel.SpendTime }} 秒</div>
      </div>
      <ng-container *ngFor="let idx of [].constructor(17); let i = index">
        <div class="json-section" *ngIf="parsedModel['item'+i]">
          <div class="json-section-title">{{ getSectionTitle(i) }}</div>
          <div class="json-section-content">
            <ng-container *ngFor="let key of objectKeys(parsedModel['item'+i])">
              <div class="json-field" *ngIf="!isArray(parsedModel['item'+i][key])">
                <span class="json-key">{{ getFieldLabel(i, key) }}：</span>
                <textarea class="json-value">{{ parsedModel['item'+i][key] }}</textarea>
              </div>
              <div class="json-field" *ngIf="isArray(parsedModel['item'+i][key]) ">
                <span class="json-key">{{ getFieldLabel(i, key) }}：</span>
                <div class="hazard-table">
                  <div class="hazard-header">
                    <div>No.</div>
                    <div>中文名稱</div>
                    <div>英文名稱</div>
                    <div>其他名稱</div>
                    <div>CasNo</div>
                    <div>Percentage</div>
                  </div>
                  <div class="hazard-row" *ngFor="let obj of parsedModel['item'+i][key]; let idx = index">
                    <div>{{ idx + 1 }}</div>
                    <div>
                      <textarea class="json-value" [(ngModel)]="obj.ChineseName"></textarea>
                    </div>
                    <div>
                      <textarea class="json-value" [(ngModel)]="obj.EnglishName"></textarea>
                    </div>
                    <div>
                      <textarea class="json-value" [(ngModel)]="obj.SimilarName"></textarea>
                    </div>
                    <div>
                      <textarea class="json-value" [(ngModel)]="obj.CasNo"></textarea>
                    </div>
                    <div>
                      <textarea class="json-value" [(ngModel)]="obj.Percentage"></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

   <div class="results-section" *ngIf="(selectedFile || selectedfileurl) && activeTab===2">
    <div class="json-preview-container">
      <div class="json-meta">
        <div *ngIf="parsedModel.SpendTime"><b>花費時間：</b>{{ parsedModel.SpendTime }} 秒</div>
      </div>
      <ng-container *ngFor="let idx of [].constructor(17); let i = index">
        <div class="json-section" *ngIf="parsedModel['item'+i]">
          <div class="json-section-title">{{ getSectionTitle(i) }}</div>
          <div class="json-section-content">
            <ng-container *ngFor="let key of objectKeys(parsedModel['item'+i])">
              <div class="json-field" *ngIf="!isArray(parsedModel['item'+i][key])">
                <span class="json-key">{{ getFieldLabel(i, key) }}：</span>
                <span class="json-value">{{ parsedModel['item'+i][key] }}</span>
              </div>
              <div class="json-field" *ngIf="isArray(parsedModel['item'+i][key]) ">
                <span class="json-key">{{ getFieldLabel(i, key) }}：</span>
                <div class="hazard-table">
                  <div class="hazard-header">
                    <div>No.</div>
                    <div>中文名稱</div>
                    <div>英文名稱</div>
                    <div>其他名稱</div>
                    <div>CasNo</div>
                    <div>Percentage</div>
                  </div>
                  <div class="hazard-row" *ngFor="let obj of parsedModel['item'+i][key]; let idx = index">
                    <div>{{ idx + 1 }}</div>
                    <div>
                      <span class="json-value">{{ obj.ChineseName }}</span>
                    </div>
                    <div>
                      <span class="json-value">{{ obj.EnglishName }}</span>
                    </div>
                    <div>
                      <span class="json-value">{{ obj.SimilarName }}</span>
                    </div>
                    <div>
                      <span class="json-value">{{ obj.CasNo }}</span>
                    </div>
                    <div>
                      <span class="json-value">{{ obj.Percentage }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

</div>


